import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import { Modal } from 'react-bootstrap';
import getLocale from '../../../i18n/getLocale';

class TrainingCertificationsModalView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      instructors_data: [],
      examiners_data: [],
      modal: false,
      loaded: 0,
    };
    //handlers
    this.closeModal = this.closeModal.bind(this);

    this.locale = getLocale();
  }
  // Handlers

  //LM
  componentWillReceiveProps(newProps) {
    if (newProps.modal_props === true) {
      this.setState({
        modal: true,
        instructors_data: newProps.instructors_data,
        examiners_data: newProps.examiners_data,
      });
    }
  }



  closeModal() {
    this.setState({
      modal: false,
    }, this.props.closeModalViewParent());
  }

  render() {
    var self = this;
    return (
      <div>
        <RequestApi ref={'request_api'} />
        <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
          <Modal.Header>
            <h4 className="pull-left">{this.locale.Treinamentos.EditarTreinamento.tabAulas.tituloVisualizarCertificadoFornecedor}</h4>
            <button className="btn btn-danger btn-sm pull-right" onClick={this.closeModal}>
            <i className="fa fa-fw fa-close"></i></button>
            <div className="clearfix"></div>
          </Modal.Header>
          <Modal.Body>
            <h4>{this.locale.Treinamentos.EditarTreinamento.tabAulas.tituloInstrutores}</h4>
            <hr/>
            <table className="table table-bordered table-hover">
              <thead>
                <tr>
                  <th className="text-center">{this.locale.Treinamentos.EditarTreinamento.tabAulas.tabelaInstrutores.Nome}</th>
                  <th className="text-center">{this.locale.Treinamentos.EditarTreinamento.tabAulas.tabelaInstrutores.Inicio}</th>
                  <th className="text-center">{this.locale.Treinamentos.EditarTreinamento.tabAulas.tabelaInstrutores.Fim}</th>
                  <th className="text-center">{this.locale.Treinamentos.EditarTreinamento.tabAulas.tabelaInstrutores.Horas}</th>
                </tr>
              </thead>
              <tbody id="training-certification-staffs">
                {Object.keys(self.state.instructors_data).map(function(k) {
                  return (
                    <tr>
                      <td className="text-center">{self.state.instructors_data[k].staff_name}</td>
                      <td className="text-center">{self.state.instructors_data[k].date_start_str}</td>
                      <td className="text-center">{self.state.instructors_data[k].date_finish_str}</td>
                      <td className="text-center">{self.state.instructors_data[k].hours}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <hr/>
            <h4>{this.locale.Treinamentos.EditarTreinamento.tabAulas.tituloExaminadores}</h4>
            <table className="table table-bordered table-hover">
              <thead>
                <tr>
                  <th className="text-center">{this.locale.Treinamentos.EditarTreinamento.tabAulas.tabelaExaminadores.Nome}</th>
                  <th className="text-center">{this.locale.Treinamentos.EditarTreinamento.tabAulas.tabelaExaminadores.Inicio}</th>
                  <th className="text-center">{this.locale.Treinamentos.EditarTreinamento.tabAulas.tabelaExaminadores.Fim}</th>
                  <th className="text-center">{this.locale.Treinamentos.EditarTreinamento.tabAulas.tabelaExaminadores.Horas}</th>
                </tr>
              </thead>
              <tbody id="training-certification-staffs">
                {Object.keys(self.state.examiners_data).map(function(k) {
                  return (
                    <tr>
                      <td className="text-center">{self.state.examiners_data[k].staff_name}</td>
                      <td className="text-center">{self.state.examiners_data[k].date_start_str}</td>
                      <td className="text-center">{self.state.examiners_data[k].date_finish_str}</td>
                      <td className="text-center">{self.state.examiners_data[k].hours}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-danger btn-sm pull-right" onClick={this.closeModal}>
            <i className="fa fa-fw fa-close"></i></button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default TrainingCertificationsModalView;



// WEBPACK FOOTER //
// ./src/Components/Trainings/Elements/TrainingCertificationsModalView.js